import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Security wrapper component that prevents browser back navigation
 * Redirects user to CNIC entry page if they try to go back
 */
function SecurityWrapper({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't apply to CNIC entry page (home page)
    if (location.pathname === '/') {
      return;
    }

    // Don't apply to admin routes
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Push a new state to history
    window.history.pushState(null, '', window.location.href);

    // Handle back/forward button
    const handlePopState = (event) => {
      // Push state again to prevent going back
      window.history.pushState(null, '', window.location.href);

      // Redirect to home/CNIC page for security
      navigate('/', { replace: true });
    };

    // Listen for back/forward button
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location.pathname]);

  return children;
}

export default SecurityWrapper;
